export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, oklch(0.97 0.025 22 / 0.95) 0%, oklch(0.985 0.004 84 / 0.98) 60%, oklch(0.94 0.07 86 / 0.9) 100%)',
      }}
    >
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/30 blur-3xl -translate-y-1/4 translate-x-1/4 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-accent-100/25 blur-3xl translate-y-1/3 -translate-x-1/4 pointer-events-none"></div>

      <div className="w-full px-4 md:px-6 py-20 md:py-24 relative z-10">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-600 text-xs font-medium mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              2024 热播推荐
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-3">
              夫妻影院
              <span className="block text-foreground-800 font-semibold text-xl sm:text-2xl md:text-3xl lg:text-4xl mt-1">
                电视剧全集免费高清在线观看
              </span>
            </h1>

            <p className="text-base md:text-lg text-primary-500 font-medium mb-5 font-heading">
              国产剧韩剧全集 · 秒播流畅不卡顿 · 每日更新
            </p>

            <div className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0 space-y-2">
              <p>
                夫妻影院是专注电视剧全集的在线观影平台，收录海量国产剧、韩剧、港剧及海外热播剧集。
                无需注册、无需下载，打开即看，全部免费高清。
              </p>
              <p>
                本站每日同步更新最新剧集，涵盖古装、悬疑、爱情、都市、职场等多元题材，
                无论你想追热播新剧还是重温经典老片，这里都能找到。
                当前平台正在热播多部年度话题剧集，涵盖国产古装巨制和韩剧浪漫佳作。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mb-7 text-xs text-foreground-500">
              <div className="flex items-center gap-1.5">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-vidicon-line text-accent-500"></i>
                </span>
                <span>每日<strong className="text-accent-600 font-semibold">30+</strong>剧集更新</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-movie-line text-accent-500"></i>
                </span>
                <span>片库总量超<strong className="text-accent-600 font-semibold">5000</strong>部</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-shield-check-line text-accent-500"></i>
                </span>
                <span>全站<strong className="text-accent-600 font-semibold">免费高清</strong>无广告</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="px-8 py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap text-sm cursor-pointer"
              >
                开始观影
                <span className="w-4 h-4 inline-flex items-center justify-center ml-1.5">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="px-8 py-3 border border-background-300 text-foreground-700 font-medium rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap text-sm cursor-pointer"
              >
                查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-100/40 rounded-3xl blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden shadow-lg aspect-[4/5]">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cinematic%20warm%20toned%20artistic%20composition%20of%20a%20cozy%20modern%20living%20room%20at%20night%20with%20a%20widescreen%20TV%20displaying%20a%20dramatic%20scene%2C%20soft%20ambient%20lighting%20from%20warm%20lamps%2C%20comfortable%20sofa%20with%20throw%20blankets%2C%20a%20couple%20silhouette%20watching%20together%2C%20movie%20posters%20on%20wall%2C%20warm%20burgundy%20and%20gold%20color%20palette%2C%20cozy%20home%20cinema%20vibe%2C%20high%20quality%20editorial%20photography%20style%2C%20minimalist%20composition%2C%20dreamy%20atmosphere&width=800&height=1000&seq=hero-drama-2026&orientation=portrait"
                  alt="夫妻影院 - 电视剧在线观影"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-2 text-white/90 text-xs">
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-play-circle-fill text-primary-300 text-lg"></i>
                    </span>
                    <span className="font-medium">高清流畅 即点即播</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}